// utils/nigeria-states.ts

import * as nigerianStates from "nigerian-states-and-lgas";
const allStates = nigerianStates.states();

export interface SelectOption {
  value: string | number;
  label: string;
}

// Get all states
export const getAllStates = (): SelectOption[] => {
  const new_state_array = allStates.map((state) =>
    state === "Federal Capital Territory" ? "FCT" : state
  );

  return new_state_array.map((state) => ({
    value: state,
    label: state,
  }));
};
